export default __webpack_public_path__ + "b7f285b.png";